import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, RouterOutlet } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { filter, tap } from 'rxjs';
import { UtilsService } from './core/services';
import { TranslateModule } from '@ngx-translate/core';
import { PwaManagerService } from './core/services/pwa-manager.service';
import { MatButtonModule } from '@angular/material/button';
import { MousePressDirective } from './shared/directives/mouse-press.directive';
import { StatusBar } from '@capacitor/status-bar';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { environment } from '@env/environment';
import { DeviceSecurityDetect } from '@capacitor-community/device-security-detect';
import { AppVersionCheckService } from './shared/services/app-version-check.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, MatButtonModule, MousePressDirective],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // string
  title = 'tc';

  // any
  installPromptEvent: any;
  public env = environment;

  // boolean
  showInstallButton = false;
  isMobileOrTablet = false;

  constructor(
    private router: Router,
    public matDialog: MatDialog,
    private utilsService: UtilsService,
    private location: Location,
    public pwaManagerService: PwaManagerService,
    private appVersionCheckService: AppVersionCheckService
  ) {
    this.utilsService.checkInternetConnection().subscribe(data => { });
    this.checkRouteChange();

    if (Capacitor.isNativePlatform()) {
      StatusBar.setOverlaysWebView({ overlay: false });
      this.handleBackButtonApplication();
      this.checkDeviceSecurity();
      this.appVersionCheckService.checkVersion();
    }
  }


  ngOnInit(): void {
    this.pwaManagerService.init();
  }

  checkRouteChange(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationStart),
      tap(() => this.matDialog.closeAll())
    ).subscribe(() => { });
  }

  //==================================
  // #region PRIVATE 
  //==================================
  private handleBackButtonApplication() {
    App.addListener('backButton', ({ canGoBack }) => {
      // If the internal web/angular history has anything to go back to
      if (canGoBack && this.router.url !== '/dashboard') {
        this.location.back();
      } else {
        // minimize App
        App.minimizeApp();
        // exit App
        // App.exitApp();
      }
    });
  }

  private async checkDeviceSecurity(): Promise<void> {
    try {
      const { value } = await DeviceSecurityDetect.isJailBreakOrRooted();
      if (value) {
        this.router.navigate(['/security-app/rooted']);
      }
    } catch (error) {
      // در صورت خطا، اجازه ادامه می‌دیم (fail-open) تا کاربران عادی بلاک نشن
    }
  }

  //#endregion
  //==================================
  // #region PWA 
  //==================================

  installPWA(): void {
    this.pwaManagerService.install();
  }

  updateNowPWA(): void {
    this.pwaManagerService.applyUpdateAndReload();
  }
  //#endregion
}
